import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "ace-builds";
import { useState } from 'react';
import AceEditor from "react-ace";
import { Breadcrumb, Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useToasts } from '../../contexts/toasts';

import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/ext-error_marker";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/webpack-resolver";
import { Telemetries } from "../../api/Telemetry";
import TherapyViewer from "../therapy/TherapyViewer";


export default function TelemetryUpload() {

    const [resultTherapy, setResultTherapy] = useState<any>(undefined);
    const { t } = useTranslation();
    const { showToast } = useToasts();
    const [telemetry, setTelemetry] = useState<string>("{}")
    const [errors, setErrors] = useState<any[]>([])
    const [toSave, setToSave] = useState<boolean>(false)


    function onChange(newValue: any, evt: any) {
        setTelemetry(newValue)
    }

    function onValidate(errors: any) {
        console.log('ERRORS:', errors)
        setErrors(errors)
    }

    const sendTelemetry = () => {
        if (!errors.length) {

            Telemetries.saveOrPreviewTelemetry(JSON.parse(telemetry), toSave).then(
                ({ data: therapy }) => {
                    setResultTherapy(therapy)
                },
                (err) => {
                    showToast!('telemetry-error', 'Invalid Json input, please check the editor', `Telemetry Json error`, 'danger');
                }
            )
        } else {

            showToast!('telemetry-error', 'Invalid Json input, please check the editor', `Telemetry Json error`, 'danger');

        }

    }
    const handleToSaveChange = () => (evt: React.ChangeEvent<any>) => {
        const value = evt.target.checked;
        setToSave(value)
    }

    const returnToTelemetry = () => { 

        setResultTherapy(undefined)

    }

    return (
        <Container>
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/ home` }}>
                    {t("pages.home") as string}
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                    Telemetry
                </Breadcrumb.Item>
            </Breadcrumb>
            <Card>

                {!resultTherapy && <Card.Body>
                    <Card.Title>Telemetry Editor</Card.Title>
                    <div className="border">
                        <AceEditor
                            placeholder="Insert Telemetry"
                            mode="json"
                            theme="github"
                            name="blah2"
                            onChange={onChange}
                            onValidate={onValidate}
                            fontSize={16}
                            lineHeight={24}
                            showPrintMargin={true}
                            showGutter={true}
                            width="100%"
                            height="75vh"
                            highlightActiveLine={true}
                            value={telemetry}
                            setOptions={{
                                enableBasicAutocompletion: false,
                                enableLiveAutocompletion: false,
                                enableSnippets: false,
                                showLineNumbers: true,
                                tabSize: 2,
                            }} />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <Form.Check
                                inline
                                className=''
                                id={'toSave'}
                                type="checkbox"
                                checked={toSave}
                                onChange={handleToSaveChange()}
                            />
                            <Form.Label>Save</Form.Label>
                        </div>
                        <Button onClick={sendTelemetry} >
                            <FontAwesomeIcon icon={toSave ? solid("save") : solid('eye')} />
                            <span className="ms-2"> {toSave ? 'Save Telemetry' : 'Test telemetry'} </span>
                        </Button>
                    </div>
                </Card.Body>
                }

                {resultTherapy && <Card.Body>
                    <Row className="align-items-center justify-content-between">
                        <Col>
                            <Card.Title>{toSave ? 'Saved Therapy' : 'Preview Therapy'}</Card.Title>
                        </Col>
                        <Col className="text-end">
                            <Button variant="light" onClick={returnToTelemetry}> <FontAwesomeIcon size="xs" icon={solid('chevron-left')} /> Back</Button>
                        </Col>
                    </Row>
                    <hr></hr>
                    <TherapyViewer resultTherapy={resultTherapy} toSave={toSave}></TherapyViewer>
                </Card.Body>}
            </Card>

        </Container>
    )
}